import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import {
    ApiBlueprint,
    discoveryApiRef,
    identityApiRef,
} from '@backstage/frontend-plugin-api';
import { isAmazonEcrAvailable } from '../components/Router';
import { amazonEcrApiRef, AwsEcrClient } from '../api';
import { rootRouteRef } from '../routes';

export const ecrEntityContentExtension = EntityContentBlueprint.make({
    name: 'ecr',
    params: {
        path: '/ecr',
        title: 'Amazon ECR',
        routeRef: rootRouteRef,
        filter: isAmazonEcrAvailable,
        loader: async () =>
            import('../components/Router').then((m) =>
                <m.Router />
            ),
    },
});


export const amazonEcrApi = ApiBlueprint.make({
    name: 'ecr',
    params: (defineParams: any) =>
        defineParams({
            api: amazonEcrApiRef,
            deps: {
                discoveryApi: discoveryApiRef,
                identityApi: identityApiRef
            },
            factory: ({
                discoveryApi,
                identityApi,
            }: any) =>
                new AwsEcrClient({ discoveryApi, identityApi }),
        }),
});